import React, { useState } from 'react'
import {
  Button,
  CardActionArea,
  CardContent,
  Container,
  Grid,
  Typography,
} from '@mui/material'
import { PersonAddAlt1, PunchClockRounded, ExitToApp } from '@mui/icons-material'
import { Link, useNavigate } from 'react-router-dom'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { StyledCard } from '../../components/StyledCard'
import { AlignedTypography } from '../../components/AlignedTypography'
import { useGetProject } from '../projects/hooks'
import { GoogleMapComponent } from '../../components/map/GoogleMapComponent'
import { KioskProjectCard } from '../../components/project/KioskProjectCard'
import { useGetTimeSheets } from '../projects/timesheets/hooks'
import { ListTimesheets } from '../projects/timesheets/ListTimesheets'
import { Fetching } from '../../components/Fetching'


const customToolBarConfig = {
    add: false,
    export: false,
    upload: false,
  }

export const Kiosk = ({ onExit }: any) => {
  const navigate = useNavigate()
  const [kioskProjectId] = useLocalStorage('kioskProject', '')
  const [kioskProjectLocation] = useLocalStorage('kioskProjectLocation', '')
  const { data: projectData, isFetching } = useGetProject('project', kioskProjectId)
  const [isExport, setIsExport] = useState(false)
  const ts = Date.now()
  const [selectedTab, setSelectedTab] = useState('Timesheets')
  if (isFetching) {
    return <Fetching />
  }
  
  return <>
    <Container maxWidth='lg' sx={{ mb: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <KioskProjectCard project={projectData} selectedLocation={kioskProjectLocation} />
        </Grid>
        <Grid item xs={12} sm={6} md={8} lg={8}>
          <StyledCard>
            <CardContent>
              {projectData ?
                <GoogleMapComponent locations={[kioskProjectLocation]} />
                : null
              }
            </CardContent>
          </StyledCard>
        </Grid>
        {/* <Grid item xs={12}> */}
        <Grid item xs={12} sm={4} >
          <StyledCard>
            <CardActionArea component={Link} to={`projects/${kioskProjectId}/geo-fence`}>
              <CardContent>
                <AlignedTypography variant='body1' gutterBottom color='primary'>
                  Clock - In / Out <PunchClockRounded sx={{ ml: 2 }} />
                </AlignedTypography>
              </CardContent>
            </CardActionArea>
          </StyledCard>
        </Grid>
        <Grid item xs={12} sm={4}>
          {projectData
            ? <StyledCard>
              <CardActionArea component={Link} to={`${projectData.account}/job-site/enrollment`}>
                <CardContent>
                  <AlignedTypography variant='body1' gutterBottom color='secondary'>
                    Jobsite Enrollment <PersonAddAlt1 sx={{ ml: 2 }} />
                  </AlignedTypography>
                </CardContent>
              </CardActionArea>
            </StyledCard>
            : null
          }
        </Grid>
        <Grid item xs={12} sm={4}>
          <StyledCard>
            <CardActionArea component={Button} onClick={onExit}>
              <CardContent>
                <AlignedTypography variant='body1' gutterBottom color='secondary'>
                  Exit Kiosk Mode? <ExitToApp sx={{ ml: 2 }} />
                </AlignedTypography>
              </CardContent>
            </CardActionArea>
          </StyledCard><br />
        </Grid>
        {/* </Grid> */}
      </Grid>
      <Typography variant='h5' gutterBottom sx={{ mt: 3 }}>Open Timesheets</Typography>
      <Grid container spacing={2} sx={{ mb: 3 }} alignItems="stretch">
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <StyledCard>
            <CardContent sx={{ height: 450, pb: 3, mb: 3 }}>
              <ListTimesheets
                queryKey='kioskTimesheets'
                keyName='kioskTimesheets'
                id={kioskProjectId}
                navigate={navigate}
                ts={ts}
                getQuery={useGetTimeSheets}
                isCheckInOut={true}
                showActionMenu={false}
                superintendents={projectData.superintendents}
                customToolBarConfig={customToolBarConfig}
                showCustomFilters={false}
                limitFieldViewForKiosk={true}
                recordStatusFilter="open"
                setIsExport={setIsExport}
                selectedTab={selectedTab}
              />
            </CardContent>
          </StyledCard>
        </Grid>
      </Grid>
    </Container>
  </>
}